import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { CircularButton } from '@kira/checkpoint-shared-frontend';
import React, { useContext } from 'react';

import useIntercom from 'hooks/useIntercom';
import { UserContext } from 'providers/UserProvider';

const BUTTON_ID = 'intercom-launcher';

const Intercom = () => {
  const { userProfile } = useContext(UserContext);

  const { isLoading } = useIntercom(BUTTON_ID, {
    name: userProfile.firstName,
    email: userProfile.email,
    company_rank: userProfile.companyRank,
    company: {
      id: userProfile.company.id,
      name: userProfile.company.name,
      created_at: userProfile.company.created_at,
      company_type: userProfile.company.company_type,
    },
  });

  const startLauncher = () => {
    window.Intercom('show');
  };

  return !isLoading ? (
    <CircularButton
      className="p-1 !shadow-none transition-colors duration-200 ease-in-out hover:bg-kira-slate-100"
      id="help-button"
      onClick={startLauncher}
    >
      <QuestionMarkCircleIcon
        className="h-7 w-7 text-kira-slate-700 !drop-shadow-none"
        aria-hidden="true"
      />
    </CircularButton>
  ) : null;
};

export default Intercom;
